export default __webpack_public_path__ + "abb14959ba0f1b37a434cd614f26f357.svg";